function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.56744 27.5163C8.56744 29.5845 9.9804 30.7954 11.5195 30.7954C12.5204 30.7954 13.1007 30.2474 13.1007 30.2474H13.1175C13.1175 30.2474 13.1091 30.38 13.1091 30.5126V30.6894H14.337V27.1186H12.1839V28.4355H13.0334V28.9216C13.0334 28.9216 12.5204 29.3812 11.8139 29.3812C10.8803 29.3812 10.0897 28.6653 10.0897 27.4633C10.0897 26.5264 10.6028 25.6779 11.8643 25.6779C12.7138 25.6779 13.3278 26.2612 13.3278 26.2612L14.0342 25.1033C14.0342 25.1033 13.2605 24.2637 11.7214 24.2637C9.88788 24.2637 8.56744 25.6779 8.56744 27.5163Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6115 30.6894H19.5391V29.3636H17.0833V24.3697H15.6115V30.6894Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0656 27.4898C20.0656 29.3459 21.3944 30.7954 23.2111 30.7954C25.0278 30.7954 26.3566 29.3459 26.3566 27.4898C26.3566 25.6779 25.0278 24.2637 23.2111 24.2637C21.3944 24.2637 20.0656 25.6779 20.0656 27.4898ZM21.5879 27.4898C21.5879 26.4557 22.3112 25.6779 23.2111 25.6779C24.111 25.6779 24.8343 26.4557 24.8343 27.4898C24.8343 28.5681 24.111 29.3812 23.2111 29.3812C22.3112 29.3812 21.5879 28.5681 21.5879 27.4898Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5287 30.6894H29.7406C30.9349 30.6894 32.0283 30.1856 32.0283 28.8067C32.0283 28.2499 31.776 27.6047 31.0863 27.3837V27.366C31.5405 27.092 31.7844 26.5529 31.7844 26.0226C31.7844 24.9354 30.9433 24.3697 29.7406 24.3697H27.5287V30.6894ZM29.0005 26.818V25.6955H29.7322C30.1275 25.6955 30.2873 25.943 30.2873 26.2347C30.2873 26.5352 30.1275 26.818 29.7575 26.818H29.0005ZM29.0005 29.3636V28.0554H29.892C30.321 28.0554 30.5228 28.3471 30.5228 28.7007C30.5228 29.0542 30.3125 29.3636 29.8836 29.3636H29.0005Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.6219 30.6894H38.1358L36.092 24.3697H34.5445L32.5008 30.6894H34.0147L34.3763 29.3636H36.2518L36.6219 30.6894ZM35.3267 25.8104C35.3267 25.8104 35.4613 26.4998 35.5706 26.8976L35.907 28.1262H34.7211L35.066 26.8976C35.1753 26.4998 35.3099 25.8104 35.3099 25.8104H35.3267Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9777 30.6894H42.9054V29.3636H40.4496V24.3697H38.9777V30.6894Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9752 30.6894H47.447V24.3697H45.9752V30.6894Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M50.1785 30.6894H51.6503V25.6955H53.4754V24.3697H48.3534V25.6955H50.1785V30.6894Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M8.52539 39.536C8.52539 39.536 9.30756 40.4376 10.7205 40.4376C12.0746 40.4376 12.84 39.5272 12.84 38.4754C12.84 36.4779 10.1318 36.6193 10.1318 35.8238C10.1318 35.4703 10.4682 35.3288 10.771 35.3288C11.4943 35.3288 12.0998 35.8857 12.0998 35.8857L12.7222 34.6218C12.7222 34.6218 12.083 33.9058 10.7878 33.9058C9.59352 33.9058 8.65996 34.6748 8.65996 35.8415C8.65996 37.786 11.3681 37.7595 11.3681 38.5108C11.3681 38.8908 11.0401 39.0146 10.7373 39.0146C9.9804 39.0146 9.29915 38.3605 9.29915 38.3605L8.52539 39.536Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M13.934 38.007C13.934 39.43 14.9264 40.4376 16.4571 40.4376C17.971 40.4376 18.9634 39.43 18.9634 38.007V34.0119H17.4916V38.007C17.4916 38.6699 17.0795 39.0234 16.4487 39.0234C15.8179 39.0234 15.4058 38.6699 15.4058 38.007V34.0119H13.934V38.007Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4613 40.3315H21.9331V38.3782H22.9592C24.1282 38.3782 24.9188 37.459 24.9188 36.1862C24.9188 34.9134 24.1282 34.0119 22.9592 34.0119H20.4613V40.3315ZM21.9331 37.0524V35.3377H22.6816C23.1694 35.3377 23.4218 35.6824 23.4218 36.1862C23.4218 36.69 23.1694 37.0524 22.6564 37.0524H21.9331Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9599 40.3315H27.4318V38.3782H28.4578C29.6269 38.3782 30.4175 37.459 30.4175 36.1862C30.4175 34.9134 29.6269 34.0119 28.4578 34.0119H25.9599V40.3315ZM27.4318 37.0524V35.3377H28.1803C28.6681 35.3377 28.9204 35.6824 28.9204 36.1862C28.9204 36.69 28.6681 37.0524 28.1551 37.0524H27.4318Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0465 37.1319C31.0465 38.988 32.3753 40.4376 34.192 40.4376C36.0087 40.4376 37.3375 38.988 37.3375 37.1319C37.3375 35.32 36.0087 33.9058 34.192 33.9058C32.3753 33.9058 31.0465 35.32 31.0465 37.1319ZM32.5688 37.1319C32.5688 36.0978 33.2921 35.32 34.192 35.32C35.0919 35.32 35.8152 36.0978 35.8152 37.1319C35.8152 38.2102 35.0919 39.0234 34.192 39.0234C33.2921 39.0234 32.5688 38.2102 32.5688 37.1319Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M38.5096 40.3315H39.9814V38.2014H40.6711L41.7392 40.3315H43.3792L42.2102 38.1219C42.0672 37.8567 41.9831 37.7418 41.9831 37.7418V37.7241C42.5802 37.4059 42.883 36.6723 42.883 36.0006C42.883 35.0814 42.4541 34.4361 41.7728 34.1621C41.5121 34.0561 41.2177 34.0119 40.6038 34.0119H38.5096V40.3315ZM39.9814 36.8756V35.3377H40.4776C41.2178 35.3377 41.386 35.6205 41.386 36.0978C41.386 36.6016 41.0916 36.8756 40.6206 36.8756H39.9814Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M45.5876 40.3315H47.0594V35.3377H48.8845V34.0119H43.7625V35.3377H45.5876V40.3315Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H62V27.4957H58.9V3.23478H3.1V61.4609H58.9V46.5632L49.3348 52.1082L47.8293 49.2805L62 41.0656V64.6957H0V0Z",
  fill: "#66BB6A"
});

var SvgLogoTransparent = function SvgLogoTransparent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoTransparent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoTransparent.de00fd6b.svg";
export { ForwardRef as ReactComponent };